<template>
  <div>
    <fieldset>
      <div class="row">
        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showorder"
            >Show order button & order form:</label
          >
          
            <b-form-checkbox
              switch
              class="ml-2"
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showorder"
              v-model="client.showorder"
            />
       
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showorderstatus"
            >Show order status:</label
          >
      
            <b-form-checkbox
              switch
              class="ml-2"
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showorderstatus"
              v-model="client.showorderstatus"
            />
        
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showtracking"
            >Show account history:</label
          >
    
            <b-form-checkbox
              switch
              class="ml-2"
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showtracking"
              v-model="client.showtracking"
            />
         
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showchangepassword"
            >Show change password:</label
          >

            <b-form-checkbox
              switch
              class="ml-2"
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showchangepassword"
              v-model="client.showchangepassword"
            />
       
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="newsiteuser"
            >Redirect to "new" site:</label
          >

            <b-form-checkbox
              switch
              class="ml-2"
              :false-value="false"
              :true-value="true"
              role="switch"
              name="newsiteuser"
              v-model="client.newsiteuser"
            />
       
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="slotmachine"
            >Show slot machine:</label
          >
   
            <b-form-checkbox
              switch
              class="ml-2"
              :false-value="false"
              :true-value="true"
              role="switch"
              name="slotmachine"
              v-model="client.slotmachine"
            />
          
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  name: "UserOptions",
  data() {
    return {};
  },
  computed: {
    client() {
      return this.$store.state.manageClients.client;
    },
  },
};
</script>
<style scoped>
.mb-4 {
   margin-bottom: 32px !important;
  }
</style>
